import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { grid } from '@finect/tabular-utils/grid';

export const Benefit = styled.div`
  display: flex;
  ${({ reverse }) => reverse && 'flex-direction: row-reverse;'};
  align-items: center;
  max-width: ${({ theme }) => theme.maxWidth};
  padding: 0 30px;
  margin: 0 auto;

  > div {
    flex-shrink: 0;
    width: 50%;
  }

  h2 {
    margin-bottom: 15px;
    ${getFont(5, 'compact')};
    font-weight: 700;

    ${maxMediaQueries.desktop`
      ${getFont(4, 'compact')};
    `};

    ${maxMediaQueries.phone`
      ${getFont(3, 'compact')};
    `};
  }

  p {
    ${getFont(1)};

    ${maxMediaQueries.desktop`
      ${getFont(0)};
    `};
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 1440px) {
    padding: 0;
  }

  ${maxMediaQueries.tablet`
    flex-wrap: wrap;
    margin: 0 auto 48px;

    > div {
      width: 100%;

      &:first-child {
        max-width: 690px;
        margin-bottom: 30px;
      }
    }

    p {
      max-width: ${grid(5)}px;
    }
  `};
`;
